function l(e, t, n = !1) {
  if (!t)
    return !1;
  t = t.replace(/^\./, "");
  const r = t.split(".");
  for (let s = 0; s < r.length; s++) {
    const i = r[s];
    if (!e || !e.hasOwnProperty(i))
      return n ? null : !1;
    e = e[i];
  }
  return n ? e : !0;
}
function u(e, t) {
  return e.toString().toLowerCase().includes(t.toString().toLowerCase());
}
function o(e, t) {
  const n = l(e, t, !0);
  return n === null ? e[t] : n;
}
function f(e, t, { value: n }) {
  const r = o(t, e);
  return r == null ? !1 : Array.isArray(n) ? n.some((s) => u(r, s)) : u(r, n);
}
export {
  f as filterItems
};
//# sourceMappingURL=utils.js.map
